import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'
import ButtonImportProductsFromXls from '../_DESIGN/PropertiesPaneButtonImportProductsFromXls.jsx'

export default function PropertiesPaneCa(props) {
    return (
        <ArchPropertiesPane
            buttons={
                <ButtonImportProductsFromXls type="cm">
                    导入用例结构
                </ButtonImportProductsFromXls>
            }

            {...props}
        />
    )
}
